import React from 'react';
import { Dialog, Button, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Warning } from '@mui/icons-material';
import { getDeleteConfirmationMessage } from '../utils/savedSearchHelpers';
import { pageContentGap } from "../../../theme";
import { SavedSearch } from '../types';

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  savedSearch: SavedSearch | null;
}

function DeleteConfirmDialog({ open, onClose, onConfirm, savedSearch }: DeleteConfirmDialogProps) {
  const theme = useTheme();
  const message = savedSearch ? 
    getDeleteConfirmationMessage(savedSearch) : 
    'Are you sure you want to delete this search?';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <div style={{
        height: "10px",
        width: "100%",
        background: theme?.palette?.error?.main || "#f44336"
      }}/>
      <Grid container style={{ padding: "12px", gap: pageContentGap }}>
        <Grid item container alignItems="center">
          <Grid item container style={{ flex: 0.2 }}>
            <Warning style={{ width: "100%", height: "55px", color: theme?.palette?.error?.main || "#f44336" }}/>
          </Grid>
          
          <Grid item container style={{ flex: 0.95, flexDirection: "column" }}>
            <Typography variant="h6" style={{ fontSize: "18px" }}>
              Delete Saved Search
            </Typography>
            {savedSearch && (
              <Typography variant="body2" style={{ fontWeight: 600, marginBottom: "8px" }}>
                "{savedSearch.name}"
              </Typography>
            )}
            <Typography variant="body1">{message}</Typography>
          </Grid>
        </Grid>
        
        <Grid item container justifyContent="flex-end" style={{ borderTop: "1px solid #DCDCDC", paddingTop: "12px", gap: pageContentGap, width: "100%" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="error" onClick={onConfirm}>Delete</Button>
        </Grid>
      </Grid>
    </Dialog>
  );
}

export default DeleteConfirmDialog;